import React, { useRef, useEffect, useState } from 'react'

import {
  FontFamily,
  Text,
  Display,
  Heading1,
  Heading2,
  TextAlign,
  useTheme,
} from '@gousto-internal/citrus-react'

import { canUseWindow } from '@library/environment'

import { HighlightChoiceBanner } from 'routes/Home/HighlightChoice'
import { homeConfig } from 'routes/Home/homeConfig'

import { GetStarted } from './GetStarted'
import { HeroImage } from './HeroImage'
import { Container, TextContainer, Title, SubTitle } from './HeroStyled'
import { ProcessImage } from './ProcessImage'
import { onScrollHandler } from './heroUtils'

export const Hero = () => {
  const { theme } = useTheme()

  const breakpointFromMedium = theme.tokens.breakpoints[0]
  const breakpointFromLarge = theme.tokens.breakpoints[1]

  const BreakpointFromMedium = `@media (min-width: ${breakpointFromMedium})`
  const BreakpointFromLarge = `@media (min-width: ${breakpointFromLarge})`

  const [isSticky, setIsSticky] = useState(false)
  const [maxHeight, setMaxHeight] = useState(0)

  const heroRef = useRef<HTMLDivElement>(null)
  const stickyCTARef = useRef<HTMLDivElement>(null)

  const onScroll = () => {
    onScrollHandler({ heroRef, stickyCTARef, setIsSticky, setMaxHeight })
  }

  useEffect(() => {
    if (canUseWindow()) {
      window.addEventListener('scroll', onScroll)
    }

    return () => {
      if (canUseWindow()) {
        window.removeEventListener('scroll', onScroll)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container
      {...{ BreakpointFromMedium, BreakpointFromLarge }}
      ref={heroRef}
      data-testid="HeroContainer"
    >
      <TextContainer {...{ BreakpointFromMedium, BreakpointFromLarge }}>
        <Title {...{ BreakpointFromMedium, BreakpointFromLarge }}>
          <Heading1
            size={[8, 9, 10]}
            textAlign={[TextAlign.Center, TextAlign.Left]}
            fontFamily={FontFamily.Bold}
          >
            {homeConfig.hero.header}
            <Text
              display={Display.Inline}
              fontFamily={FontFamily.UI}
              style={{ verticalAlign: 'super' }}
            >
              *
            </Text>
          </Heading1>
        </Title>
        <SubTitle>
          <Heading2
            size={[4, 5]}
            textAlign={[TextAlign.Center, TextAlign.Left]}
            fontFamily={FontFamily.Bold}
          >
            {homeConfig.hero.subheader}
          </Heading2>
        </SubTitle>

        <HighlightChoiceBanner data-testid="highlightChoiceBanner" />

        <GetStarted ref={stickyCTARef} isHeroCTA isSticky={isSticky} maxHeight={maxHeight} />
        <ProcessImage />
      </TextContainer>
      <HeroImage />
      <GetStarted ref={stickyCTARef} isHeroCTA={false} isSticky={isSticky} maxHeight={maxHeight} />
    </Container>
  )
}
